import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PublicGdprPortalModel } from '../models/public-GDPR-portal.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';

@Injectable()
export class PortalService {
    constructor(private httpClient: HttpClient) {}
    // to get portal by token
    getPortal(): Observable<PublicGdprPortalModel> {
        return this.httpClient.get<PublicGdprPortalModel>(environment.apiInboxUrl + 'GdprPortal/');
    }
}
